import ScaleLoader from "react-spinners/ScaleLoader";
import React from "react";

export const loaderStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
}

export default function Loader() {
    return <div style={loaderStyle}>
        <div>
            <ScaleLoader color="#FFB81C" width={4} margin={4} height={56}/>
        </div>
    </div>
}